// @flow

import { type CardBrand } from '@tectonics/prs/card-brand';

import amex from './amex.svg';
import carnet from './carnet.svg';
import diners from './diners.svg';
import discover from './discover.svg';
import elo from './elo.svg';
import hipercard from './hipercard.svg';
import mastercard from './mastercard.svg';
import visa from './visa.svg';
import rupay from './rupay.svg';
import privateLabel from './private-label.svg';
import generic from './generic-front.svg';

export function getCardBrandImageSrc(cardBrand: ?CardBrand): string {
  switch(cardBrand) {
    case 'amex': return amex;
    case 'carnet': return carnet;
    case 'diners': return diners;
    case 'discover': return discover;
    case 'elo': return elo;
    case 'hipercard': return hipercard;
    case 'mastercard': return mastercard;
    case 'visa': return visa;
    case 'rupay': return rupay;
    case 'private': return privateLabel;
    default: return generic;
  }
}
